module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "notfound tjhzs-main-content"
  }, [_c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.time))]), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_c('p', [_vm._v("已偏离我们的路线！" + _vm._s(_vm.time) + " 秒后返回首页")])])]), _vm._v(" "), _c('header-show')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-528b9532!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/404.vue
// module id = 180
// module chunks = 1